import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Comment } from 'shared/models';

@Injectable({
  providedIn: 'root',
})
export class CommentAPIService {
  constructor(private _http: HttpClient) {}

  // 댓글 목록
  getComments(memo_id: string): Observable<{
    total: number;
    hidden_count: number;
    items: Comment[];
  }> {
    return this._http.get<{
      total: number;
      hidden_count: number;
      items: Comment[];
    }>(`/api/v1/memos/${memo_id}/comments`, {
      withCredentials: true,
    });
  }

  // 댓글 생성
  createComment(
    memo_id: string,
    content: string,
    mention_user_id: string
  ): Observable<Comment> {
    return this._http.post<Comment>(
      `/api/v1/memos/${memo_id}/comments`,
      {
        content,
        mention_user_id,
      },
      {
        withCredentials: true,
      }
    );
  }

  // 답글 생성
  createReply(
    memo_id: string,
    content: string,
    mention_user_id: string,
    comment_id: string
  ): Observable<Comment> {
    return this._http.post<Comment>(
      `/api/v1/memos/${memo_id}/comments`,
      { content, mention_user_id, comment_id },
      { withCredentials: true }
    );
  }

  // 댓글 수정
  updateComment(
    memo_id: string,
    content: string,
    mention_user_id: string,
    comment_id: string
  ): Observable<Comment> {
    return this._http.put<Comment>(
      `/api/v1/memos/${memo_id}/comments/${comment_id}`,
      {
        content,
        mention_user_id,
      },
      { withCredentials: true }
    );
  }

  // 답글 수정
  updateReply(
    memo_id: string,
    content: string,
    mention_user_id: string,
    reply_id: string
  ): Observable<Comment> {
    return this._http.put<Comment>(
      `/api/v1/memos/${memo_id}/comments/${reply_id}`,
      { content, mention_user_id },
      { withCredentials: true }
    );
  }

  // 댓글 삭제
  deleteComment(memo_id: string, comment_id: string): Observable<void> {
    return this._http.delete<void>(
      `/api/v1/memos/${memo_id}/comments/${comment_id}`,
      { withCredentials: true }
    );
  }

  // 댓글 신고
  reportComment(
    memo_id: string,
    comment_id: string,
    reason: string,
    details: string,
    block: boolean
  ): Observable<void> {
    return this._http.put<void>(
      `/api/v1/memos/${memo_id}/comments/${comment_id}/report`,
      { reason, details, block },
      { withCredentials: true }
    );
  }

  // 댓글 추천
  recommendComment(memo_id: string, comment_id: string): Observable<void> {
    return this._http.put<void>(
      `/api/v1/memos/${memo_id}/comments/${comment_id}/like`,
      {},
      { withCredentials: true }
    );
  }

  // 댓글 추천 취소
  unRecommendComment(memo_id: string, comment_id: string): Observable<void> {
    return this._http.delete<void>(
      `/api/v1/memos/${memo_id}/comments/${comment_id}/like`,
      { withCredentials: true }
    );
  }

  // 댓글 차단
  blockComment(memo_id: string, comment_id: string): Observable<void> {
    return this._http.put<void>(
      `/api/v1/memos/${memo_id}/comments/${comment_id}/block`,
      {},
      { withCredentials: true }
    );
  }
}
